<template>
  <div class="cont-ziliao have-tit" v-loading="fullscreenLoading">
    <div class="user-much-num">个人资料</div>
    <div class="jiben-infoes">
<!--      <div class="avatar">-->
<!--        <img class="avatar-img" :src="infoes.imgUrl" alt="">-->
<!--        <div class="change" @click="showUploadImg" v-if="isSelf">-->
<!--          <i class="el-icon-camera-solid"></i>-->
<!--          <span>修改我的头像</span>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="set-name">-->
<!--        <div class="cont-name">-->
<!--          <input-->
<!--            ref="nameinput"-->
<!--            class="center-name"-->
<!--            :class="{'active': contenteditable}"-->
<!--            v-model="infoes.userName"-->
<!--            :disabled="!contenteditable"-->
<!--          />-->
<!--          <span class="change-name" @click="changeName" v-if="isSelf">-->
<!--            <i class="icon"></i>{{contenteditable === false ? '修改' : '确定'}}-->
<!--          </span>-->
<!--        </div>-->
<!--      </div>-->
      <div class="form-cont">
        <div class="form-tit">基本资料</div>
        <div class="form-item-one"  v-if="isSelf">
          <div class="left-tit">真实姓名</div>
          <div class="right-ipt">
            <el-input class="one" v-model="infoes.realName" placeholder="请输入真实姓名"></el-input>
            <el-select class="two" v-model="infoes.realNameVisibility" placeholder="请选择">
              <el-option
                v-for="item in Qoptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="form-item-one"  v-if="!isSelf&&infoes.realNameVisibility==1">
          <div class="left-tit">真实姓名</div>
          <div class="right-ipt">
            <div class="only-show">{{infoes.realName}}</div>
          </div>
        </div>
        <div class="form-item-one"  v-if="isSelf">
          <div class="left-tit">性别</div>
          <div class="right-ipt">
            <el-radio-group v-model="infoes.gender">
              <el-radio :label="0">女</el-radio>
              <el-radio :label="1">男</el-radio>
            </el-radio-group>
            <el-select class="two" v-model="infoes.genderVisibility" placeholder="请选择">
              <el-option
                v-for="item in Qoptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="form-item-one"  v-if="!isSelf&&infoes.genderVisibility==1">
          <div class="left-tit">性别</div>
          <div class="right-ipt">
            <div class="only-show">{{infoes.gender==0?"女":"男"}}</div>
          </div>
        </div>
        <div class="form-item-one"  v-if="isSelf">
          <div class="left-tit">手机</div>
          <div class="right-ipt">
            <el-input class="one" v-model="infoes.contactPhone" placeholder="请输入手机号" disabled></el-input>
            <el-select class="two" v-model="infoes.phoneVisibility" placeholder="请选择">
              <el-option
                v-for="item in Qoptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="form-item-one"  v-if="!isSelf&&infoes.phoneVisibility==1">
          <div class="left-tit">手机</div>
          <div class="right-ipt">
            <div class="only-show">{{infoes.contactPhone}}</div>
          </div>
        </div>
        <div class="form-item-one" v-if="isSelf">
          <div class="left-tit">邮箱</div>
          <div class="right-ipt">
            <el-input class="one" v-model="infoes.contactEmail" placeholder="请输入邮箱"></el-input>
            <el-select class="two" v-model="infoes.emailVisibility" placeholder="请选择">
              <el-option
                v-for="item in Qoptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="form-item-one"  v-if="!isSelf&&infoes.emailVisibility==1">
          <div class="left-tit">邮箱</div>
          <div class="right-ipt">
            <div class="only-show">{{infoes.contactEmail}}</div>
          </div>
        </div>
        <div class="form-item-one" v-if="isSelf">
          <div class="left-tit">所在地</div>
          <div class="right-ipt">
            <el-cascader :placeholder="showLocation" v-model="regionPath"  :props="props"></el-cascader>
          </div>
        </div>
        <div class="form-item-one"  v-if="!isSelf">
          <div class="left-tit">所在地</div>
          <div class="right-ipt">
            <div class="only-show">{{showLocation}}</div>
          </div>
        </div>
        <div class="form-item-one" v-if="isSelf">
          <div class="left-tit">擅长领域</div>
          <div class="right-ipt">
            <el-input class="one all" v-model="infoes.introduction"  @input="checkLength(2)" placeholder="请输入擅长领域" ></el-input>
          </div>
        </div>
        <div class="form-item-one"  v-if="!isSelf">
          <div class="left-tit">擅长领域</div>
          <div class="right-ipt">
            <div class="only-show">{{infoes.introduction}}</div>
          </div>
        </div>
        <div class="form-item-one" v-if="isSelf">
          <div class="left-tit">个性签名</div>
          <div class="right-ipt">
            <el-input class="one all" v-model="infoes.signature" @input="checkLength(1)" placeholder="请输入用户签名" ></el-input>
          </div>
        </div>
        <div class="form-item-one"  v-if="!isSelf">
          <div class="left-tit">个性签名</div>
          <div class="right-ipt">
            <div class="only-show">{{infoes.signature}}</div>
          </div>
        </div>
        <div class="form-sublit">
          <el-button @click="setUseInfo" v-if="isSelf">保存</el-button>
        </div>
      </div>
    </div>
    <div class="gaoji-infoes">
      <div class="form-cont">
        <div class="form-tit">高级资料</div>
        <div class="form-item-one" v-if="isSelf">
          <div class="left-tit">教育经历</div>
          <div class="right-ipt">
            <el-input class="one textarea" type="textarea" rows="4" v-model="infoes.educationExpirence" placeholder=""></el-input>
            <el-select class="two" v-model="infoes.educationExpirenceVisibility" placeholder="请选择">
              <el-option
                v-for="item in Qoptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="form-item-one"  v-if="!isSelf&&infoes.educationExpirenceVisibility==1">
          <div class="left-tit">教育经历</div>
          <div class="right-ipt">
            <div class="only-show">{{infoes.educationExpirence}}</div>
          </div>
        </div>
        <div class="form-item-one" v-if="isSelf">
          <div class="left-tit">工作经历</div>
          <div class="right-ipt">
            <el-input class="one textarea" type="textarea" rows="4" v-model="infoes.workExprience" placeholder=""></el-input>
            <el-select class="two" v-model="infoes.workExprienceVisibility" placeholder="请选择" v-if="isSelf">
              <el-option
                v-for="item in Qoptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="form-item-one"  v-if="!isSelf&&infoes.workExprienceVisibility==1">
          <div class="left-tit">工作经历</div>
          <div class="right-ipt">
            <div class="only-show">{{infoes.workExprience}}</div>
          </div>
        </div>
        <div class="form-sublit" v-if="isSelf">
          <el-button @click="setUseInfo">保存</el-button>
        </div>
      </div>
    </div>
    <!-- 上传图片弹窗 -->
    <el-dialog
      title="上传图片"
      :visible.sync="dialogUploadImg"
      top="100px"
      :width="screen === 'desktop' ? '500px' : '90%'"
      :modal-append-to-body="false"
    >
      <div class="cut-img" v-loading="imageLoading">
        <div class="cropper-wrap-f">
          <div class="cropper-wrap">
            <vue-cropper
                    ref="cropper"
                    :img="option.img"
                    :fixed="option.fixed"
                    :autoCrop="option.autoCrop"
                    :autoCropWidth="option.autoCropWidth"
                    :autoCropHeight="option.autoCropHeight"
                    :outputType="option.outputType"
                    mode="cover"
            >
            </vue-cropper>
          </div>
        </div>
        <div class="btns">
          <label class="btn"><input type="file" id="uploads" style="position:absolute; clip:rect(0 0 0 0);" accept="image/png, image/jpeg, image/gif, image/jpg" @change="uploadImg($event)">{{option.img === '' ? '上传' : '重新选择'}}图片</label>
        </div>
      </div>
      <span slot="footer" class="dialog-footer" v-if="isSelf">
        <el-button type="primary" @click="setAvatar">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
  // import {VueCropper} from 'vue-cropper'
import axios from 'axios';
import vue from 'vue';
vue.prototype.$axios = axios;
import qs from 'qs';

  import { mapState } from "vuex";
  import updateTdk from "@/utils/tdk";

vue.prototype.qs = qs;
  import userApi from '@/api/user'
  let id=0
export default {
  components: {
   // VueCropper
  },
  data () {
    let that=this;
    return {
      headTitle: "title---rrdh",
      headKeywords: "keywords---rrdh",
      headDesc: "description---rrdh",
      isMounted: false, //for control not ssr render

      regionPath:[],
        showLocation:"",
      nodes:[],
      props: {
        lazy: true,
        lazyLoad (node, resolve) {
          that.initData(node, resolve);
        }
      },
      isSelf:false,
      form: {
        id:0,
        nickName:'',
        name: '',
        email: '',
      },
      fullscreenLoading: true,
      imageLoading:false,
      userId:0,
      screen: '',
      oldSignature:"",
      oldIntroduction:"",
      dialogUploadImg: false,
      option: {
        img: '', // require('./cropper.jpg')
        fixed: true, // 是否开启截图框宽高固定比例
        autoCrop: true, // 是否显示截图框
        autoCropWidth: 200, // 截图框默认宽度
        autoCropHeight: 200, // 截图框默认高度
        outputType: 'jpeg' // 图片输出格式
      },
      contenteditable: false,
      Qoptions: [
        {
          value: 0,
          label: '仅自己可见'
        },
        {
          value: 1,
          label: '所有人可见'
        }
      ],

      infoes: {

      }
    }
  },
  computed: {
    ...mapState(["userDetail"])
  },
  tdk() {
    return {
      title: this.headTitle,
      description: this.headDesc,
      keywords: this.headKeywords,
      ssrHeadAddInfo: `<link rel="canonical" href="http://www.renrendonghua.com">`
    };
  },
  serverPrefetch() {
    return this.fetchData();
  },
  destroyed() {
    this.$store.commit("SET_USER_DETAIL", { detail: null });
  },

  beforeMount () {
    window.addEventListener('resize', this.resizeHandler)
    // import {VueCropper} from 'vue-cropper'
    //this.$options.components.VueCropper = () =>import('vue-cropper');

    let thiss =this
    const VueCropperBak = () => import("vue-cropper")
    VueCropperBak().then(res =>{
      thiss.$options.components.VueCropper = res.default.VueCropper
    })
  },
  mounted () {

    this.isMounted = true;

    this.resizeHandler()
    let userId=this.$route.query.userId;
    this.userId=userId;


    const alreadyIncremented = !!this.productionDetail;
    if (!alreadyIncremented) {
      this.fetchData().then(this.initDataMount());
    } else {
      this.initDataMount();
    }




  },
  methods: {
    fetchData(){
      return this.$store
              .dispatch("FETCH_USER_DETAIL", {
                id: this.$route.query.userId
              })
              .finally(() => {
                this.$loading(false);
                this.setSeo()
                updateTdk.call(this);
              });
    },
    initDataMount(){
      this.getUserInfo();
    },
    setSeo(){
      this.headTitle = this.userDetail.userName+"的个人资料——人人动画网【官网】";
      this.headKeywords = this.userDetail.impressStr;
      this.headDesc =this.userDetail.userName+"的个人资料";
    },



    initData(node, resolve){
      console.log("node",node)
      let nodes =[]
      // 通过调用resolve将子节点数据返回，通知组件数据加载完成
      let _this=this;

      let parentId=1;
      if(node.level>0){
          parentId=node.value
      }
      let url="/rrbi/region/getRegionByParentId?parentId="+parentId+"&ti="+new Date().getMilliseconds();
      _this.$axios.get(url).then(function(result){
          nodes=result.data
          console.log(nodes)
          resolve(nodes);
      })

    },
    getUserInfo(){
      let _this=this;
      _this.fullscreenLoading = true
      let url="/rrbi/userInfo/userInfo-one?userId="+this.userId+"&ti="+new Date().getMilliseconds();
      _this.$axios.get(url).then(function(result){
        console.log(result.data.response)
        _this.infoes=result.data.response;
        if(_this.infoes.introduction==null||_this.infoes.introduction==undefined){
          _this.infoes.introduction='';
          _this.oldIntroduction=""
        }else{
          _this.oldIntroduction=_this.infoes.introduction
        }
        if(_this.infoes.signature==null||_this.infoes.signature==undefined){
          _this.infoes.signature='';
          _this.oldSignature=""
        }else{
          _this.oldSignature=_this.infoes.signature
        }
        _this.isSelf=result.data.response.isSelf;
        _this.showLocation=result.data.response.showLocation
        _this.fullscreenLoading = false
        // document.title =_this.infoes.userName+"的个人资料——人人动画网【官网】"
        // document.querySelector('meta[name="description"]').setAttribute('content', _this.infoes.userName+"的个人资料")
      })
    },
    isMobile () {
      const WIDTH = 750
      const deviceWidth = document.body.getBoundingClientRect().width
      return deviceWidth <= WIDTH
    },
    resizeHandler () {
      if(this.isMobile()) {
        this.screen = 'mobile'
      } else {
        this.screen = 'desktop'
      }
    },
    showUploadImg () {
      this.dialogUploadImg = true
    },
    uploadImg (e) {
      //上传图片
      var file = e.target.files[0]
      if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
        alert('图片类型必须是.gif,jpeg,jpg,png,bmp中的一种')
        return false
      }
      var reader = new FileReader()
      reader.onload = (e) => {
        let data
        if (typeof e.target.result === 'object') {
          // 把Array Buffer转化为blob 如果是base64不需要
          data = window.URL.createObjectURL(new Blob([e.target.result]))
        } else {
          data = e.target.result
        }

        this.option.img = data
      }
      // 转化为base64
      // reader.readAsDataURL(file)
      // 转化为blob
      reader.readAsArrayBuffer(file)
    },
    setAvatar () {
      this.imageLoading = true
      // 输出bolb格式地址
      let this_ = this
      /*
      this_.$refs.cropper.getCropBlob((data) => {
        var img = window.URL.createObjectURL(data)
        console.log("输出bolb格式地址==",img);
      })
*/
      // 输出base64格式
      this_.$refs.cropper.getCropData((data) => {
        //console.log("输出base64格式==",data);
        this_.uploadBase64File(data)
      })
    },
    uploadBase64File(base64Data){
      var _this = this
      var url = "/avatar/base64Upload";

      let postData = {base64Data:base64Data,appid:125,userid:_this.userId}


      userApi.updateImg(postData).then(data => {
        if(data.code ===1){
          this.$message.success("更新成功，即将刷新页面")
          this.imageLoading=false
          this.dialogUploadImg = false
          this.timer = setTimeout(()=>{   //设置延迟执行
            window.location.reload()
          },1000);

        }else{
          _this.$message.error(data.message)
        }
        _this.formLoading = false
      })

      /*
      axios.post(url,_this.qs.stringify(postData)).then((res) => {
        //console.log("上传成功");
        window.location.reload()
        _this.formLoading = false
      }).catch(e => {
        _this.formLoading = false
      })

/*
      axios.post(url,_this.qs.stringify(postData)).then((res) => {
        console.log("上传成功",res.data);
        if(res.result != 3){
          console.log("上传成功");
        }else{
          console.log("上传失败");
        }
        _this.formLoading = false
      }).catch(e => {
        _this.formLoading = false
      })

 */
    },
    checkLength(type){

      let oldStr="";
      let str="";
      if(type==1){
        oldStr=this.oldSignature;
        str=this.infoes.signature;
      }else{
        oldStr=this.oldIntroduction;
        str=this.infoes.introduction;
      }
      let strs=str.split('');
      let strLength=0;
      let re=/[^\u4e00-\u9fa5]/;
      strs.forEach(function (e) {
        if(!re.test(e)){
          strLength=strLength+2
        }else{
          strLength=strLength+1
        }
      })
      if(strLength>24){
        if(type==1) {
          this.infoes.signature = oldStr;
        }else{
          this.infoes.introduction = oldStr;
        }
      }else{
        if(type==1) {
          this.infoes.signature=str;
          this.oldSignature=this.infoes.signature;
        }else{
          this.infoes.introduction=str;
          this.oldIntroduction=this.infoes.introduction;
        }

      }
      // return strLength;
    },
    setUseInfo(){
      let _this=this;
      _this.fullscreenLoading = true;
      let url="/rrbi/userInfo/userInfo-update";
        console.log(_this.regionPath.length)
      if(_this.regionPath.length>0){
          let regionPath=_this.regionPath.join(",");
          this.infoes.location=","+regionPath+","
      }

      // if(_this.checkLength(_this.infoes.signature)>24){
      //   this.$message.error("个性签名中文字符长度x2加非文字符长度不能大于24")
      //   return false;
      // }
      // if(_this.checkLength(_this.infoes.introduction)>24){
      //   this.$message.error("擅长领域中文字符长度x2加非文字符长度不能大于24")
      //   return false;
      // }
      _this.$axios.post(url, _this.infoes).then(function(result){

        _this.form.id=_this.infoes.userId
        // _this.form.name=_this.infoes.realName
        _this.form.nickname=_this.infoes.userName
        _this.form.name=_this.infoes.userName
        _this.form.email=_this.infoes.contactEmail
        _this.form.gender = _this.infoes.gender
        _this.timer = setTimeout(()=>{   //设置延迟执行
        userApi.update(_this.form).then(data => {
          _this.$message.success("更新成功，即将刷新页面")

            window.location.reload()

        })
        },1000);
        // _this.infoes=result.data.response;
      })
    },
    changeName () {
      if (this.contenteditable === false) {
        this.contenteditable = true
        this.$nextTick(function () {
          this.$refs.nameinput.select()
        }) 
      } else {
        this.contenteditable = false
        console.log(this.infoes.userName)
          let _this=this;
          let url="/rrbi/userInfo/userInfo-update";
          _this.$axios.post(url, _this.infoes).then(function(result){
            // _this.infoes=result.data.response;
            _this.form.id=_this.infoes.userId
            // _this.form.name=_this.infoes.realName
            _this.form.nickName=_this.infoes.userName
            _this.form.name=_this.infoes.userName
            _this.form.email=_this.infoes.contactEmail
            userApi.update(_this.form).then(data => {
              _this.$message.success("更新成功，即将刷新页面")
              _this.timer = setTimeout(()=>{   //设置延迟执行
                window.location.reload()
              },1000);
            })

          })
      }
    }
  }
}
</script>

<style scoped lang="less">
.jiben-infoes{
  padding: 20px 0;
  background: #fff;
  .avatar{
    overflow: hidden;
    position: relative;
    margin: 0 auto;
    width: 140px;
    height: 140px;
    border-radius: 50%;
    .avatar-img{
      width: 100%;
    }
    .change{
      position: absolute;
      left: 0;top: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
      color: #fff;
      background: rgba(0, 0, 0, .3);
      cursor: pointer;
      i{
        font-size: 50px;
      }
      span{
        margin-top: 5px;
        font-size: 14px;
      }
    }
  }
  .set-name{
    margin: 20px 0;
    text-align: center;
    .cont-name{
      position: relative;
      display: inline-block;
      .center-name{
        padding: 4px 5px;
        width: 200px;
        line-height: 25px;
        font-size: 18px;
        text-align: center;
        color: #4c4c4c;
        font-weight: bold;
        background: none;
        &.active{
          background: #f5f5f5;
          outline: #1a79e4 solid 1px;
        }
      }
      .change-name{
        position: absolute;
        left: 100%;top: 9px;
        margin-left: 5px;
        display: flex;
        align-items: center;
        width: 50px;
        font-size: 12px;
        line-height: 15px;
        color: #1a79e4;
        cursor: pointer;
        .icon{
          margin-right: 2px;
          display: block;
          width: 15px;
          height: 15px;
          background-image: url('../../../assets/images/icon_change_name.png')
        }
      }
    }
  }
}
.gaoji-infoes{
  margin-top: 20px;
  padding: 20px 0;
  background: #fff;
}
.form-cont{
  margin: 0 auto;
  width: 680px;
  .form-tit{
    color: #4c4c4c;
    font-size: 16px;
    font-weight: bold;
  }
  .form-item-one{
    margin-top: 20px;
    display: flex;
    .left-tit{
      flex: 0 0 100px;
      width: 100px;
      height: 32px;
      line-height: 32px;
      text-align: right;
      font-size: 14px;
    }
    .right-ipt{
      margin-left: 20px;
      flex: 1;
      display: flex;
      .one{
        width: 220px;
        flex: 0 0 220px;
        &.all{
          width: 100%;
          flex: 1;
        }
        &.textarea{
          flex: 1;
          /deep/textarea{
            background: #f5f5f5;
          }
        }
        /deep/input{
          background: #f5f5f5;
        }
      }
      .two{
        margin-left: 10px;
        width: 150px;
        flex: 0 0 150px;
        /deep/input{
          background: #f5f5f5;
        }
      }
      .el-radio-group{
        display: flex;
        align-items: center;
        width: 220px;
        flex: 0 0 220px;
      }
      .only-show{
        padding: 5px 0;
        font-size: 14px;
        line-height: 22px;
        word-break: break-all;
      }
    }
  }
  .form-sublit{
    margin-top: 40px;
    text-align: center;
  }
}
// 裁剪缩略图
.cut-img{
  .cropper-wrap-f{
    position: relative;
    padding-bottom: 100%;
    width: 100%;
    height: 0;
    .cropper-wrap{
      position: absolute;
      left: 0;right: 0;
      top: 0;bottom: 0;
    }
  }
  .btns{
    margin-top: 20px;
    text-align: center;
    .btn{
      display: inline-block;
      width: 100%;
      line-height: 32px;
      color: #fff;
      font-size: 12px;
      background: #4e90ff;
      border-radius: 4px;
      cursor: pointer;
      box-sizing: border-box;
      &:hover{
        background: rgb(64,158,255)
      }
    }
  }
}
@media screen and (max-width: 750px){
  .form-cont{
    padding: 0 10px;
    width: 100%;
    .form-item-one{
      .left-tit{
        flex: 0 0 60px;
        width: 50px;
        font-size: 12px;
      }
      .right-ipt{
        margin-left: 10px;
        .one,
        .el-radio-group{
          flex: 1;
          width: auto;
        }
        .two{
          flex: 0 0 120px;
        }
      }
    }
  }
}
</style>
